export default "__VITE_ASSET__BQP2fyx___"